import React, { useState, useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";
import Switch from "react-switch";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";

const CompanyAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let { adminStaffForSearch } = useContext(UserContext);

  // States hook here
  //new group
  let [newCompany, setNewCompany] = useState({
    id: null,
    name: "",
    phn_no: "",
    address: "",
    sntn_no: "",
    edit: false,
    editSlug: null,
    uploading: false,
    status: 1,
  });

  useEffect(() => {
    if (params.id && adminStaffForSearch) {
      setLoading(true);
      handleSetEdit(params.id);
    }
  }, [adminStaffForSearch]);

  // on change send req
  const handleChangeStatus = () => {
    setNewCompany({
      ...newCompany,
      status: newCompany.status ? 0 : 1,
    });
  };

  //set name, phn no, address hook
  const handleSetNewCompany = (e) => {
    setNewCompany({ ...newCompany, [e.target.name]: e.target.value });
  };

  //Save New company
  const handleSaveNewCompany = (e) => {
    e.preventDefault();

    setNewCompany({
      ...newCompany,
      uploading: true,
    });
    const companyUrl = BASE_URL + `/settings/company`;
    let formData = new FormData();
    formData.append("name", newCompany.name);
    formData.append("phn_no", newCompany.phn_no);
    formData.append("address", newCompany.address);
    formData.append("sntn_no", newCompany.sntn_no);
    formData.append("status", newCompany.status);

    return axios
      .post(companyUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewCompany({
          id: null,
          name: "",
          phn_no: "",
          address: "",
          sntn_no: "",
          edit: false,
          editSlug: null,
          uploading: false,
          status: 1,
        });
        setLoading(false);
        toast.success(`${_t(t("Company has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        history.push("/dashboard/manage/restaurant/companies");
      })
      .catch((error) => {
        console.log("check error==>", error);
        setLoading(false);
        setNewCompany({
          ...newCompany,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //set edit true & values
  const handleSetEdit = async (id) => {
    try {
      const url = BASE_URL + "/settings/company/" + id;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      if (res.data) {
        const company = res.data;

        setNewCompany({
          ...newCompany,
          id: company.id,
          name: company.name,
          phn_no: company.phn_no,
          address: company.address,
          sntn_no: company.sntn_no || "",
          editSlug: company.slug,
          status: parseInt(company.status),
          edit: true,
        });
      }
      setLoading(false);
    } catch {
      setLoading(false);
      toast.error("Please try again", {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //update company
  const handleUpdateCompany = (e) => {
    e.preventDefault();

    setNewCompany({
      ...newCompany,
      uploading: true,
    });
    const companyUrl = BASE_URL + `/settings/company/` + newCompany.id;
    let formData = {
      name: newCompany.name,
      phn_no: newCompany.phn_no,
      address: newCompany.address,
      sntn_no: newCompany.sntn_no,
      status: newCompany.status,
    }
    // new FormData();
    // formData.append("name", newCompany.name);
    // formData.append("phn_no", newCompany.phn_no);
    // formData.append("address", newCompany.address);
    // formData.append("sntn_no", newCompany.sntn_no);
    // formData.append("status", newCompany.status);

    return axios
      .put(companyUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewCompany({
          id: null,
          name: "",
          phn_no: "",
          address: "",
          sntn_no: "",
          edit: false,
          editSlug: null,
          uploading: false,
          status: 1,
        });
        setLoading(false);
        toast.success(`${_t(t("Company has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        history.push("/dashboard/manage/restaurant/companies");
      })
      .catch(() => {
        setLoading(false);
        setNewCompany({
          ...newCompany,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Company"))}</title>
      </Helmet>

      {/* Add modal */}
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {newCompany.uploading === true || loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="fragment3">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!newCompany.edit
                                    ? _t(t("Add new Company"))
                                    : _t(t("Update Company"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>
                        {/* form start here */}
                        <div key="fragment-company-1">
                          <form
                            onSubmit={
                              !newCompany.edit
                              ? handleSaveNewCompany
                              : handleUpdateCompany
                            }
                            className="row card p-2 mx-3 mb-5 new-text-style"
                            autoComplete="off"
                          >
                            <div className="row">
                              <div className="form-group col-6 mt-3">
                                <label htmlFor="name" className="form-label">
                                  {_t(t("Name"))}{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="name"
                                  name="name"
                                  placeholder="e.g company name"
                                  value={newCompany.name || ""}
                                  required
                                  onChange={handleSetNewCompany}
                                />
                              </div>
                              <div className="form-group mt-3 col-6">
                                <label htmlFor="address" className="form-label">
                                  {_t(t("Address"))}
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="address"
                                  name="address"
                                  placeholder="Type company address"
                                  value={newCompany.address || ""}
                                  onChange={handleSetNewCompany}
                                />
                              </div>
                            </div>

                            <div className="row mb-3">
                              <div className="form-group mt-3 col-3">
                                <label htmlFor="phn_no" className="form-label">
                                  {_t(t("Phone Number"))}
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="phn_no"
                                  name="phn_no"
                                  maxLength={14}
                                  placeholder="e.g. 01xxx xxx xxx"
                                  value={newCompany.phn_no || ""}
                                  onChange={handleSetNewCompany}
                                />
                              </div>

                              <div className="col-3">
                                <div className="mt-3">
                                  <label
                                    htmlFor="sntn_no"
                                    className="form-label"
                                  >
                                    {_t(t("Sntn No"))}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    onWheel={(e) => e.target.blur()}
                                    id="sntn_no"
                                    name="sntn_no"
                                    onChange={handleSetNewCompany}
                                    value={newCompany.sntn_no || ""}
                                  />
                                </div>
                              </div>

                              {/* <div className="col-3">
                              </div> */}

                              <div className="col-3">
                                <div className="mt-3">
                                  <label
                                    htmlFor="sntn_no"
                                    className="form-label d-block"
                                  >
                                    {_t(t("Status"))}
                                  </label>
                                  <Switch
                                    onChange={handleChangeStatus}
                                    checked={newCompany.status}
                                    className="react-switch ml-1 mt-1"
                                    name="status"
                                    height={22}
                                    width={44}
                                    offColor="#ee5253"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mt-4">
                              <div className="d-flex justify-content-end">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={()=>(history.push("/dashboard/manage/restaurant/companies"))}
                                  >
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary rounded"
                                  >
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i> {!newCompany.edit ? _t(t("Save")) : _t(t("Update"))}
                                  </button>
                                </div>
                              </div>
                            </div>   
                          </form>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default CompanyAction;
